import React from 'react';

export const LocationAddress = ({ location }) => {
  // fragment for formatting an address
  return (
    <>
      {location.service_area_only == false && location.street && (
        <>
          {location.street}
          {location.street2 && <>, {location.street2}</>}
          <br />
        </>
      )}
      {location.city}, {location.state} {location.postal_code}
    </>
  );
};
